export const getCardStyle = (theme) => ({
  background:
    theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
  borderRadius: "1rem",
  padding: "30px",
  marginTop: -40,
  marginBottom: "70px",
  boxShadow:
    theme === "dark"
      ? "0 0.5rem 2rem rgba(0,0,0,0.3), inset 0 0.0625rem 0 rgba(255,255,255,0.1)"
      : "0 0.5rem 2rem rgba(0,0,0,0.1)",
  backdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
  WebkitBackdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
  border:
    theme === "dark"
      ? "1px solid rgba(255,255,255,0.15)"
      : "1px solid rgba(0,0,0,0.05)",
});

export const getThHeaderStyle = (theme) => ({
  padding: "14px 16px",
  textAlign: "center",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  background:
    theme === "dark"
      ? "linear-gradient(135deg, rgba(55, 65, 81, 0.8), rgba(75, 85, 99, 0.8))"
      : "linear-gradient(135deg, rgba(248, 250, 252, 0.95), rgba(241, 245, 249, 0.95))",
  color: theme === "dark" ? "#f1f5f9" : "#1e293b",
  borderBottom:
    theme === "dark"
      ? "2px solid rgba(59, 130, 246, 0.3)"
      : "2px solid rgba(59, 130, 246, 0.1)",
  whiteSpace: "nowrap",
  position: "sticky",
  top: 0,
  zIndex: 10,
  backdropFilter: "blur(0.625rem)",
  boxShadow:
    theme === "dark"
      ? "0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.3)"
      : "0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1)",
  transition: "all 0.3s ease",
});

export const getTdStyle = (theme) => ({
  padding: "14px 16px",
  fontSize: "13px",
  textAlign: "center",
  color: theme === "dark" ? "rgba(255,255,255,0.85)" : "#475569",
  borderBottom:
    theme === "dark"
      ? "1px solid rgba(59, 130, 246, 0.1)"
      : "1px solid rgba(59, 130, 246, 0.05)",
});

export const getActionButtonStyle = (theme, disabled = false) => ({
  padding: "8px 12px",
  borderRadius: "8px",
  border: "none",
  background: disabled
    ? theme === "dark"
      ? "rgba(51, 65, 85, 0.5)"
      : "rgba(241, 245, 249, 0.7)"
    : theme === "dark"
      ? "rgba(71, 85, 105, 0.6)"
      : "rgba(226, 232, 240, 0.8)",
  color: disabled
    ? theme === "dark" ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)"
    : theme === "dark" ? "#f1f5f9" : "#334155",
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.6 : 1,
  fontSize: "12px",
  fontWeight: "600",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  transition: "all 0.2s ease",
});

export const getTopBarButtonStyle = (theme, disabled = false) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "8px 16px",
  borderRadius: "8px",
  border: "1px solid rgba(255,255,255,0.15)",
  background: disabled
    ? theme === "dark" ? "rgba(100, 116, 139, 0.3)" : "rgba(203, 213, 225, 0.3)"
    : theme === "dark"
      ? "rgba(30, 41, 59, 0.8)"
      : "rgba(51, 65, 85, 0.12)",
  color: disabled
    ? theme === "dark" ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)"
    : theme === "dark" ? "#f1f5f9" : "#1e293b",
  fontWeight: "500",
  cursor: disabled ? "not-allowed" : "pointer",
  fontSize: "13px",
  transition: "all 0.2s ease",
  opacity: disabled ? 0.6 : 1,
});